// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"419":"bab98c66","923":"9be0a54b"}[chunkId] + ".css";
};